import React from 'react';

interface SimpleToggleProps {
  value: boolean;
  setValue: (value: boolean) => void;
}

const SimpleToggle: React.FC<SimpleToggleProps> = ({ value, setValue }) => {
  const handleToggle = () => {
    setValue(!value);
  };

  return (
    <button 
      className={`btn btn-xxs btn-seconadary ${value ? 'active' : ''}`}
      onClick={handleToggle}
      aria-pressed={value}
    >
      {value ? 'ON' : 'OFF'}
    </button>
  );
};

export default SimpleToggle; 